var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:tw-flex tw-items-start tw-h-auto"},[_c('EventContent',{attrs:{"contenu":_vm.event}}),_c('EventSide',{attrs:{"contenu":_vm.event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }